import { __module as e } from "../../../_virtual/isBoolean.js";
import { a as o } from "./util/assertString.js";
Object.defineProperty(t = e.exports, "__esModule", {
  value: !0
}), t.default = function (e) {
  var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;
  return ((0, s.default)(e), o.loose) ? l.includes(e.toLowerCase()) : a.includes(e);
}, s = o && o.__esModule ? o : {
  default: o
}, r = {
  loose: !1
}, l = [].concat(a = ["true", "false", "1", "0"], ["yes", "no"]), e.exports = t.default, e.exports.default = t.default;
var t,
  s,
  r,
  a,
  l,
  u = e.exports;
export { u as i };